import React from 'react';
import Layout from '../../shared/components/Layout';
import PolicyPolicyMain from '../components/PolicyPolicyMain';

const PrivacyPolicy = () => {
  return (
    <React.Fragment>
      <Layout>
        <PolicyPolicyMain />
      </Layout>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
